// src/pages/ValidarEnlace.js
import React, { useEffect, useState } from "react";
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";

const ValidarEnlace = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [authSuccess, setAuthSuccess] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [showOpenPWA, setShowOpenPWA] = useState(false);
  const [isInsidePWA, setIsInsidePWA] = useState(false);

  useEffect(() => {
    // Detectar si es mobile
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    setIsMobile(isMobileDevice);

    // Detectar si está dentro de la PWA (standalone mode)
    const isPWA = window.matchMedia('(display-mode: standalone)').matches ||
                  window.navigator.standalone === true;
    setIsInsidePWA(isPWA);

    const auth = getAuth();
    const url = window.location.href;
    const emailLocal = window.localStorage.getItem("emailForSignIn");

    if (isSignInWithEmailLink(auth, url)) {
      // Si es mobile y NO está en la PWA, mostrar botón para abrir PWA
      if (isMobileDevice && !isPWA) {
        setShowOpenPWA(true);
        return;
      }

      // Si está en desktop O dentro de la PWA, procesar autenticación normalmente
      const email = emailLocal || window.prompt("Ingresa tu correo para continuar:");

      if (!email) {
        setAuthError("Debes ingresar tu correo para completar el inicio de sesión.");
        return;
      }

      signInWithEmailLink(auth, email, url)
        .then(() => {
          window.localStorage.removeItem("emailForSignIn");
          setAuthSuccess(true);

          // Redirigir al dashboard después de autenticar
          setTimeout(() => {
            window.location.href = "/dashboard";
          }, 1500);
        })
        .catch((error) => {
          console.error("Error al iniciar sesión:", error);
          setAuthError("No se pudo iniciar sesión. Intenta nuevamente.");
        });
    }
  }, []);

  const openInPWA = () => {
    // Mostrar instrucciones claras para usar la PWA
    alert('Para completar tu inicio de sesión:\n\n1. Busca el ícono de PUX en tu pantalla de inicio\n2. Abre la app PUX\n3. Ingresa tu correo nuevamente\n4. Recibirás un nuevo magic link\n5. Abre ese link desde dentro de la app');
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      padding: '2rem',
      textAlign: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
    }}>
      {showOpenPWA && (
        <>
          <div style={{ fontSize: '4rem', marginBottom: '2rem' }}>📱</div>
          <h2 style={{ margin: '0 0 1.5rem 0', fontSize: '1.6rem', fontWeight: '600' }}>
            Usa la app PUX instalada
          </h2>
          <div style={{
            backgroundColor: 'rgba(255,255,255,0.15)',
            borderRadius: '16px',
            padding: '1.5rem',
            marginBottom: '1.5rem',
            maxWidth: '400px',
            textAlign: 'left'
          }}>
            <p style={{ margin: '0 0 1rem 0', fontSize: '0.95rem', fontWeight: '600' }}>
              Para iniciar sesión:
            </p>
            <ol style={{ margin: 0, paddingLeft: '1.2rem', fontSize: '0.9rem', lineHeight: '1.8' }}>
              <li>Busca el ícono de PUX en tu pantalla de inicio</li>
              <li>Abre la app PUX</li>
              <li>Ingresa tu correo</li>
              <li>Abre el nuevo magic link desde dentro de la app</li>
            </ol>
          </div>
          <p style={{ fontSize: '0.85rem', opacity: 0.7, maxWidth: '350px', lineHeight: '1.5' }}>
            Los magic links solo funcionan cuando se abren desde dentro de la app instalada
          </p>
        </>
      )}

      {!showOpenPWA && !authSuccess && !authError && (
        <>
          <div style={{
            border: '4px solid rgba(255, 255, 255, 0.3)',
            borderTop: '4px solid white',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 1s linear infinite',
            marginBottom: '2rem'
          }}></div>
          <h3 style={{ margin: 0, fontSize: '1.5rem' }}>Validando enlace...</h3>
        </>
      )}

      {authSuccess && (
        <>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✓</div>
          <h3 style={{ margin: '0 0 1rem 0', fontSize: '1.5rem' }}>Autenticación exitosa</h3>
          <p style={{ opacity: 0.9 }}>Redirigiendo al dashboard...</p>
        </>
      )}

      {authError && (
        <>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✗</div>
          <h3 style={{ margin: '0 0 1rem 0', fontSize: '1.5rem', color: '#ff6b6b' }}>Error</h3>
          <p style={{ opacity: 0.9 }}>{authError}</p>
          <button
            onClick={() => window.location.href = "/"}
            style={{
              marginTop: '2rem',
              padding: '12px 24px',
              fontSize: '1rem',
              fontWeight: '600',
              backgroundColor: 'white',
              color: '#667eea',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            Volver al inicio
          </button>
        </>
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ValidarEnlace;
